<div class="trip-log">
  @if (loading) {
    <p class="trip-log-empty">Loading logs…</p>
  } @else if (!entries.length) {
    <p class="trip-log-empty">No log entries for this trip.</p>
  } @else {
    <ol>
      @for (entry of entries; track $index) {
        <li>
          <time>{{ when(entry.time) }}</time>
          <div>
            <b>{{ entry.kind }}</b>
            <span>{{ entry.actor }}</span>
            <p>{{ entry.message }}</p>
          </div>
        </li>
      }
    </ol>
  }
  @if (note) { <p class="trip-log-note">{{ note }}</p> }
  @if (adminNote) { <p class="trip-log-note">{{ adminNote }}</p> }
</div>
